const defaultCompanies = {};
const companies = (state = defaultCompanies, action) => {
  switch (action.type) {
    case 'GET_COMPANIES_SUCCESS':
      return { ...action.companies };
    default:
      return state;
  }
};

export default companies;
